export type CallProgressStage = "quote" | "signature" | "service" | "result";

export const callProgressStages: CallProgressStage[] = [
  "quote",
  "signature",
  "service",
  "result",
];

export function callProgressCopy(stage: CallProgressStage, elapsedSeconds: number): {
  title: string;
  detail: string;
} {
  if (stage === "quote") {
    return {
      title: "正在获取支付要求",
      detail: "平台正在确认本次调用的 Token、金额与收款地址。",
    };
  }
  if (stage === "signature") {
    return {
      title: "等待钱包确认",
      detail: "请在钱包中签署付款授权。签名完成后会自动继续。",
    };
  }
  if (stage === "service") {
    return {
      title: "正在查询服务",
      detail: elapsedSeconds >= 8
        ? "服务仍在处理中，请保持窗口打开，不要重复提交。"
        : "支付授权已提交，正在等待目标接口返回结果。",
    };
  }
  return {
    title: "正在整理返回结果",
    detail: "服务已经响应，正在校验结算状态并生成结果页面。",
  };
}
